import Vuex  from 'vuex'
import Vue  from 'vue'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
});

export default store;